import React, { useEffect, useState } from "react";
import {
    ButtonGroup,
    Col,
    Container,
    Dropdown,
    DropdownButton,
    Form,
    Row,
    Tab,
    Tabs,
} from "react-bootstrap";

//components
import Table from "../../Components/TableTemplate/Table";
import Navbar from "../../Components/Navbar/Navbar";
import DeleteModal from "../../Components/Modals/DeleteModal";
import AddModal from "../../Components/Modals/AddModal";
import EditModal from "../../Components/Modals/EditModal";
import ViewModal from "../../Components/Modals/ViewModal";
import * as XLSX from "xlsx";

//css
import "../../Components/Navbar/Navbar.css";

import { branchesMockData } from "../../Helpers/mockData/mockData";
import {
    createBranch,
    deleteBranch,
    getAllBranches,
    searchBranch,
    updateBranch,
} from "../../Helpers/apiCalls/Manage/Branches";
import toast from "react-hot-toast";
import {
    toastStyle,
    refreshPage,
    isAdmin,
    formatDate,
    TokenExpiry,
    capitalizeFirstLetter,
    getTodayDateISO,
    numberFormat,
    getBranchId,
    getType
} from "../../Helpers/Utils/Common";
import {
    faGaugeSimpleMed,
    faListNumeric,
} from "@fortawesome/free-solid-svg-icons";
import { validateBranches } from "../../Helpers/Validation/Manage/BanchesValidation";
import InputError from "../../Components/InputError/InputError";
import ReactDatePicker from "react-datepicker";
import { setMinutes, setHours } from "date-fns";
import Moment from "moment";
import { getAllPriceLevels } from "../../Helpers/apiCalls/Manage/PriceLevels";
import { useNavigate } from "react-router-dom";
import { getAllBranchesPotato } from "../../Helpers/apiCalls/PotatoCorner/Purchases/purchaseOrderApi";
import {
    createBranchPotato,
    deleteBranchPotato,
    searchBranchPotato,
    updateBranchPotato,
} from "../../Helpers/apiCalls/PotatoCorner/Manage/Branches";
import {
    getAllBranchGroup,
    getAllBranchGroupPotato,
} from "../../Helpers/apiCalls/Manage/BranchGroupApi";
import {
    getAllInventoryGroup,
    getAllInventoryGroupPotato,
} from "../../Helpers/apiCalls/Manage/InventoryGroup";
import DatePicker from "react-datepicker";
import { CSVLink, CSVDownload } from "react-csv";
import downloadIcon from "../../Assets/Images/download_icon.png";
import Footer from "../../Components/Footer/Footer";
import TableWithDynamicPagination from "../../Components/TableTemplate/TableWithDynamicPagination";

export default function Stores() {
    const accountType = getType();
    const [inactive, setInactive] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [option, setOption] = useState("Select");
    const [isClicked, setIsClicked] = useState(false);
    const [selectedType, setSelectedType] = useState("");
    let navigate = useNavigate();
    const [addTo, setAddTo] = useState("MANGO MAGIC");
    const [excelData, setExcelData] = useState([]);

    // MODALS //
    // DELETE
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const handleShowDeleteModal = () => setShowDeleteModal(true);
    const handleCloseDeleteModal = () => setShowDeleteModal(false);

    // VIEW
    const [showViewBranchModal, setShowViewBranchModal] = useState(false);
    const handleShowViewBranchModal = () => setShowViewBranchModal(true);
    const handleCloseViewBranchModal = () => setShowViewBranchModal(false);

    // EDIT
    const [showEditBranchModal, setShowEditBranchModal] = useState(false);
    const handleShowEditBranchModal = () => setShowEditBranchModal(true);
    const handleCloseEditBranchModal = () => setShowEditBranchModal(false);

    // ADD
    const [showAddBranchModal, setShowAddBranchModal] = useState(false);
    const handleShowAddBranchModal = () => setShowAddBranchModal(true);
    const handleCloseAddBranchModal = () => {
        setAddTo("")
        setShowAddBranchModal(false);
    }

    const handleAddSelect = (e) => {
        setAddTo(e);
    };
    const xlsxHeaders =  [
        "BRANCH NAME",
        "TYPE",
        "OPEN DAYS",
        "OPEN TIMES",
        "ADDRESS",
        "PHONE NUMBER",
        "INITIAL CASH IN DRAWER",
        "STATUS",
    ]

    //API
    const [branchesData, setBranchesData] = useState([]);
    const [filterConfig, setFilterConfig] = useState({
        name: "",
        is_franchise: "0",
        date: "",
        branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
        page: 1
    });
    const [selectedRow, setSelectedRow] = useState({
        name: "",
        address: "",
        contact_person_no: "",
        phone_no: "",
        tin_no: "",
        bir_no: "",
        franchisee_name: "",
        franchisee_contact_no: "",
        contract_start: "",
        contract_end: "",
        opening_date: "",
        price_level: "",
        contact_person: "",
    });
    const [priceLevel, setPriceLevels] = useState([]);

    //ERROR HANDLING
    const [isError, setIsError] = useState({
        name: false,
        address: false,
        inventory_group_id: false,
        phone_no: false,
        initial_drawer: false,
        price_level: false,
        contact_person: false,
        contact_person_no: false,
        is_franchise: false,
        monthly_rental_fee: false,
    });

    const [isErrorEdit, setIsErrorEdit] = useState({
        name: false,
        address: false,
        inventory_group_id: false,
        phone_no: false,
        initial_drawer: false,
        price_level: false,
        contact_person: false,
        contact_person_no: false,
        is_franchise: false,
        monthly_rental_fee: false,
    });

    const [osStartTime, setOsStartTime] = useState(new Date());
    const [osEndTime, setOsEndTime] = useState(new Date());

    const [deliveryStartTime, setDeliveryStartTime] = useState(new Date());
    const [deliveryEndTime, setDeliveryEndTime] = useState(new Date());

    const [osStartTimeEdit, setOsStartTimeEdit] = useState(new Date());
    const [osEndTimeEdit, setOsEndTimeEdit] = useState(new Date());

    const [deliveryStartTimeEdit, setDeliveryStartTimeEdit] = useState(
        new Date()
    );
    const [deliveryEndTimeEdit, setDeliveryEndTimeEdit] = useState(new Date());

    const [addBranchData, setAddBranchData] = useState({
        name: "",
        address: "",
        phone_no: "",
        inventory_group_id: "",
        contact_person_no: "",
        monthly_rental_fee: "",
        tin_no: "",
        bir_no: "",
        franchisee_name: "",
        franchisee_contact_no: "",
        contract_start: "",
        contract_end: "",
        opening_date: "",
        price_level: "",
        contact_person: "",
        initial_drawer: "",
        os_startDate: "monday",
        os_endDate: "sunday",
        os_startTime: "",
        os_endTime: "",
        delivery_startDate: "monday",
        delivery_endDate: "sunday",
        delivery_startTime: "",
        delivery_endTime: "",
        is_franchise: "",
    });

    const [editBranchData, setEditBranchData] = useState({
        id: "",
        name: "",
        address: "",
        phone_no: "",
        contact_person_no: "",
        inventory_group_id: "",
        monthly_rental_fee: "",
        tin_no: "",
        bir_no: "",
        franchisee_name: "",
        franchisee_contact_no: "",
        contract_start: "",
        contract_end: "",
        opening_date: "",
        price_level: "",
        contact_person: "",
        operation_schedule: "",
        delivery_schedule: "",
        is_franchise: "",
    });
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this based on your requirement

    const handlePageChange = page => {
        setCurrentPage(page);
        setFilterConfig(prev => ({
        ...prev,
        page: page,
        }));
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    };


    function handleOnSearch(e) {
        const { name, value } = e.target;
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    async function searchBranches() {
        setBranchesData([]);
        setExcelData([]);
        setShowLoader(true);
        setTotalItems(0)
        const response = await searchBranch(filterConfig);
        if (response.data) {
            setTotalItems(response.data.size);
            var allData = response.data.data.map((branch) => {
                var formattedOperationTimes = "";

                if (branch.operation_times !== null) {
                    var operationTimes = branch.operation_times.split("-");
                    if (operationTimes.length === 2) {
                        var startTime = operationTimes[0].trim();
                        var endTime = operationTimes[1].trim();

                        var startHour = parseInt(startTime.split(":")[0]);
                        var endHour = parseInt(endTime.split(":")[0]);

                        // Determine AM/PM based on hour
                        var startSuffix = startHour >= 12 ? "PM" : "AM";
                        var endSuffix = endHour >= 12 ? "PM" : "AM";

                        // Convert hour to 12-hour format
                        startHour = startHour % 12 || 12;
                        endHour = endHour % 12 || 12;

                        // Format start time
                        var formattedStartTime = ("0" + startHour).slice(-2) + ":" + startTime.split(":")[1] + startSuffix;
                        // Format end time
                        var formattedEndTime = ("0" + endHour).slice(-2) + ":" + endTime.split(":")[1] + endSuffix;
                        formattedOperationTimes = formattedStartTime + " - " + formattedEndTime;
                    }
                }

                return {
                    branch_name: branch.name,
                    status: branch.status,
                    address: branch.address,
                    operation_days: branch.operation_days.split("-").length === 2 ? branch.operation_days : "",
                    operation_times: formattedOperationTimes,
                    phone_number: branch.contact_person_no || branch.phone_no,
                    initial_cash: numberFormat(branch.initial_drawer),
                    branch_type: branch.is_franchise === "0" ? "Company-owned - Mango" : branch.is_franchise === "1" ? "Franchise Branch" : "Others",
                    action_btn: ActionBtn(branch, "mango"),
                };
            });
            setBranchesData(allData);

            var excel = allData.map((bill) => {
                var info = {};
                info.branch_name = bill.branch_name
                info.branch_type = bill.branch_type
                info.operation_days = bill.operation_days
                info.operation_times = bill.operation_times
                info.address = bill.address
                info.phone_number = bill.phone_number
                info.initial_cash = bill.initial_cash
                info.status = bill.status
                return info;
            });
            setExcelData(excel);

        }
        setShowLoader(false);
    }

    async function del() {
        setIsClicked(true);
        if (selectedType === "mango") {
            const response = await deleteBranch(selectedRow.id);
            if (response) {
                if (response.data.status === "success") {
                    toast.success(response.data.response, {
                        style: toastStyle(),
                    });
                    setTimeout(() => refreshPage(), 1000);
                } else {
                    toast.error(response.data.response, {
                        style: toastStyle(),
                    });
                }
            } else {
                toast.error(response.data.response, {
                    style: toastStyle(),
                });
            }
        }
    }

    //DROPDOWN
    function handleSelectChange(e, row, type) {
        setSelectedRow(row);
        setSelectedType(type);
        setEditBranchData(row);
        if (e.target.value === "delete-branch") {
            handleShowDeleteModal();
        } else if (e.target.value === "edit-branch") {
            if (row.operation_schedule !== "") {
                var OsSchedule = row.operation_schedule.split("-");
                row.os_startDate = OsSchedule[0];
                row.os_endDate = OsSchedule[2];

                var start = "";
                start = new Date(OsSchedule[1]);
                var end = "";
                end = new Date(OsSchedule[3]);

                setOsStartTimeEdit(start);
                setOsEndTimeEdit(end);
            }

            if (row.delivery_schedule !== "") {
                var deliverySchedule = row.delivery_schedule.split("-");
                row.delivery_startDate = deliverySchedule[0];
                setDeliveryStartTimeEdit(new Date(deliverySchedule[1]));
                row.delivery_endDate = deliverySchedule[2];
                setDeliveryEndTimeEdit(new Date(deliverySchedule[3]));
            }

            setEditBranchData(row);
            handleShowEditBranchModal();
        } else if (e.target.value === "view-branch") {
            handleShowViewBranchModal();
        } else {
            handleShowDeleteModal();
        }
    }

    function ActionBtn(row, type) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action form-select"
                id={row}
                onChange={(e) => handleSelectChange(e, row, type)}
                value={option}
            >
                <option defaulValue selected hidden>
                    Select
                </option>
                <option value="view-branch" className="color-options">
                    View
                </option>
                {isAdmin && (
                    <option value="edit-branch" className="color-options">
                        Edit
                    </option>
                )}
                {isAdmin && (
                    <option value="delete-branch" className="color-red">
                        Delete
                    </option>
                )}
            </Form.Select>
        );
    }

    function handleExport() {
        const rows = excelData
        
        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
        XLSX.utils.sheet_add_aoa(worksheet, [xlsxHeaders], { origin: "A1" });
        XLSX.writeFile(workbook, "ListOfStores.xlsx", { compression: true });
    }

    //onEdit
    function handleOnEdit() {
        handleCloseViewBranchModal();
        handleShowEditBranchModal();
    }

    function renderBranchType(type) {
        switch (type) {
            case "0":
                return `BRANCH DETAILS (Company-owned branch)`;
            case "1":
                return `BRANCH DETAILS (Franchise branch)`;
            default:
                return `BRANCH DETAILS`;
        }
    }

    //API CALL

    useEffect(() => {
        searchBranches();
        // fetchBranchGroup();
        // fetchInventoryGroup();
    }, [filterConfig, currentPage]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"STORE REPORTS"} 
                />
            </div>
            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                <Row className="mb-4">
                    <Col xs={12} lg={9}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> LIST OF STORES </h1>
                    </Col>
                    <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            name="name"
                            className="search-bar"
                            onChange={handleFilterChange}
                            placeholder="Search branch name..."
                        />
                    </Col>
                </Row>
                <div className="tab-content">
                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                        <Col xs={6} lg={2}>
                        <DatePicker
                            autoComplete="off"
                            selected={filterConfig.date_from}
                            name="date_from"
                            placeholderText={"Select Date To"}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_from: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter me-4 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                            autoComplete="off"
                            selected={filterConfig.date_to}
                            name="date_to"
                            placeholderText={"Select Date From"}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_to: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter ps-label-content me-5 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                    </Row>
                    <div className="mb-2" />

                    <TableWithDynamicPagination
                        tableHeaders={[
                            "BRANCH NAME",
                            // "TYPE",
                            "OPEN DAYS",
                            "OPEN TIMES",
                            "ADDRESS",
                            "PHONE NUMBER",
                            "INITIAL CASH IN DRAWER",
                            "CONTRACT STATUS",
                        ]}
                        headerSelector={[
                            "branch_name",
                            // "branch_type",
                            "operation_days",
                            "operation_times",
                            "address",
                            "phone_number",
                            "initial_cash",
                            "status",
                        ]}
                        tableData={branchesData}
                        showLoader={showLoader}
                        withActionData={true}
                        // used in dynamic pagination
                        totalItems={totalItems}
                        currentPage={currentPage}
                        itemsPerPage={itemsPerPage}
                        handlePageChange={handlePageChange}
                    />
                </div>
                <div className="mb-3" />
                <br /><br />
                <Row>
                    <Col lg={10}></Col>
                    <Col lg={2} className="mt-3 mt-lg-0">
                    <div className="PO-filters">
                        <button
                            type="button"
                            className="primary-btn"
                            onClick={handleExport}
                        >
                            <span className="me-2">
                                <img
                                    width={20}
                                    height={20}
                                    src={downloadIcon} alt=""
                                ></img>
                            </span>
                            Download
                        </button>
                    </div>
                    </Col>
                </Row>
                <div className="mb-3" />
                <br /><br />
            </div>
            {/* MODALS */}
            <DeleteModal
                text="branch"
                show={showDeleteModal}
                onHide={handleCloseDeleteModal}
                onDelete={() => del()}
                isClicked={isClicked}
            />
            <Footer/>
        </div>
    );
}
